import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiDataFieldViewClusterComponent } from './cluster/cluster.component';
import { FiDataFieldViewNameComponent } from './name/name.component';
import { FiDataFieldViewEmailAddressComponent } from './email-address/email-address.component';
import { FiDataFieldViewAreasComponent } from './areas/areas.component';
import { FiDataFieldViewBusinessAreasComponent } from './business-areas/business-areas.component';
import { FiDataFieldViewDescriptionComponent } from './description/description.component';
import { FiDataFieldViewComponent } from './data-field-view.component';
import { FiDataFieldViewPhoneNumberComponent } from './phone-number/phone-number.component';
import { FiDataFieldViewCustomComponent } from './custom/custom.component';
import { FiDataFieldViewAddressComponent } from './address/address.component';
import { FiStateSrefModule } from '@fi-app/shared/fi-state-proxy/state-sref/state-sref.module';
import { FiTelHrefModule } from '@fi-app/utilities/tel-href/tel-href.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiDataFieldViewCustomCalendarComponent } from './custom-calendar/custom-calendar.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FiDataFieldViewCustomPreSetOptionsComponent } from './custom-pre-set-options/custom-pre-set-options.component';
import { FiProfileViewModule } from '@fi-app/components/profile-view/profile-view.module';
import { FiDataFieldViewActiveComponent } from '@fi-app/data-field/data-field-view/active/active.component';
import { FiDataFieldViewRolesComponent } from '@fi-app/data-field/data-field-view/roles/roles.component';
import { FiDataFieldViewTagsComponent } from '@fi-app/data-field/data-field-view/tags/tags.component';
import { FiDataFieldViewUnitsComponent } from '@fi-app/data-field/data-field-view/units/units.component';
import { FiDataFieldViewOrgNrComponent } from './org-nr/org-nr.component';

@NgModule({
    imports: [
        CommonModule,
        FiStateSrefModule,
        FiTelHrefModule,
        FiAppTextSharedModule,
        UtilitiesModule,
        FiProfileViewModule,
    ],
    declarations: [
        FiDataFieldViewComponent,
        FiDataFieldViewNameComponent,
        FiDataFieldViewDescriptionComponent,
        FiDataFieldViewClusterComponent,
        FiDataFieldViewAreasComponent,
        FiDataFieldViewBusinessAreasComponent,
        FiDataFieldViewPhoneNumberComponent,
        FiDataFieldViewEmailAddressComponent,
        FiDataFieldViewAddressComponent,
        FiDataFieldViewActiveComponent,
        FiDataFieldViewCustomComponent,
        FiDataFieldViewCustomCalendarComponent,
        FiDataFieldViewCustomPreSetOptionsComponent,
        FiDataFieldViewRolesComponent,
        FiDataFieldViewTagsComponent,
        FiDataFieldViewUnitsComponent,
        FiDataFieldViewOrgNrComponent,
    ],
    exports: [FiDataFieldViewComponent],
})
export class FiDataFieldViewModule {}
